<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  departmentComputed,
  departmentListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'
export default {
  page: {
    title: 'Department List',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Table,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      departmentlist: {},
      allDeptList: {},
      collegelist: [],
      allCollegeList: [],
      collegeId: 'All',
      siteconfiglist: [],
      platformId: 'All',
      isUserAdmin: false,
      fields: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'dept_college_id',
          text: 'College Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        {
          key: 'name',
          label: 'Name',
          colType: 'default',
        },
        {
          key: 'college_id',
          label: 'College Name',
          colType: 'default',
        },
      ],
    }
  },
  computed: {
    ...departmentComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getColleges()
    this.getListOfDepartments()
  },
  methods: {
    ...departmentListMethod,
    ...collegeListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getDepartments() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allDeptList.docs.forEach((element) => {
          if (element.colgId === this.collegeId) {
            listitems.push(element)
          }
        })
        this.departmentlist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.departmentlist.docs = this.allDeptList.docs
        } else {
          let listitems = []
          this.allDeptList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.departmentlist.docs = listitems
        }
      }
    },

    // Get list of all departments
    getListOfDepartments() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({
        filter,
      })
        .then((departmentList) => {
          this.departmentlist = departmentList
          this.allDeptList = JSON.parse(JSON.stringify(departmentList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allDeptList.docs.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.departmentlist.docs = listitems
      } else {
        this.departmentlist.docs = this.allDeptList.docs
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              tag="button"
              to="/department-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add Department</span> </router-link
            ><br /><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getDepartments"
              ></b-form-select>
            </b-form-group>
            <Table
              :fields="fields"
              :items="departmentlist ? departmentlist.docs : []"
              :editbtn="true"
              :viewbtn="true"
              :deletebtn="true"
              :department="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
